import {getFromSeanet} from "../actions/networkActions";
import {useCallback, useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {saveSeanetVodData} from "../actions/seanetVodActions";
import {useSeanetLocale} from "./useSeanetLocale";
import {getSeanetLocaleInfo} from "../utils/vodUtils";

export const useSeanetGenres = (genreId) => {
    const seanetVodData = useSelector(state => state.seanetVod.data);
    const dataValidUntil = useSelector(state => state.seanetVod.dataValidUntil);
    const {seanetLocale} = useSeanetLocale();
    const [prevSeanetLocale, setPrevSeanetLocale] = useState(seanetLocale);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const fetchSeanetVod = useCallback(async () => {
        setLoading(true);
        setError(false);

        try {
            const masterData = await getFromSeanet(`${seanetLocale}/master.json`);

            if (!masterData || !Array.isArray(masterData.index)) {
                console.error('Seanet VOD data missing or malformed', masterData);
                setError(true);
                return;
            }

            const genres = {};
            const allLocales = new Set();

            for (const entry of masterData.index) {
                entry.genres.push({
                    id: 0,
                    name: getSeanetLocaleInfo(seanetLocale).allMoviesGenreTitle
                });
                if (entry.locales.includes(seanetLocale)) {
                    for (const genre of entry.genres) {
                        if(!genres[genre.id]) {
                            genres[genre.id] = {
                                id: genre.id,
                                name: genre.name,
                                movies: []
                            };
                        }

                        genres[genre.id].movies.push({
                            title: entry.title,
                            path: `${entry.path}`,
                            locales: entry.locales.filter(Boolean),
                            image: entry.preferredCover,
                        });
                    }
                }
                for (const locale of entry.locales) {
                    if (locale) {
                        allLocales.add(locale)
                    }
                }
            }
            saveSeanetVodData(genres, allLocales);
        } catch (error) {
            console.error('Call to getFromSeanet failed', error);
            setError(true);
        } finally {
            setLoading(false);
        }
    }, [seanetLocale]);

    useEffect(() => {
        if(new Date().getTime() > dataValidUntil || !seanetVodData) {
            fetchSeanetVod();
        }

        if (seanetLocale !== prevSeanetLocale) {
            setPrevSeanetLocale(seanetLocale);
            fetchSeanetVod();
        }
    }, [seanetVodData, genreId, dataValidUntil, seanetLocale, prevSeanetLocale, fetchSeanetVod]);

    if(genreId) {
        return { seanetVodData: seanetVodData?.[genreId], error, loading };
    }

    return { seanetVodData, error, loading };
};